module.exports = {
  APP_ENVIRONMENT: "preproduction",
  APP_PORT: 8080,
};

